import { z } from 'zod';
import { JsonSchema } from '../../../helpers';
import { ConfigsStepPostSignQaTranslations } from './configs-step-post-sign-qa-translations';

export const ConfigsStepPostSignQa = z.object({
  id: z.string().uuid(),
  metadata: JsonSchema.nullable(),
  translate: ConfigsStepPostSignQaTranslations.optional(),
  is_visible: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ConfigsStepPostSignQaT = z.infer<typeof ConfigsStepPostSignQa>;

export const ConfigsStepPostSignQaInsert = ConfigsStepPostSignQa.partial();

export type ConfigsStepPostSignQaInsertT = z.infer<
  typeof ConfigsStepPostSignQaInsert
>;

export const ConfigsStepPostSignQaUpdate = ConfigsStepPostSignQa.omit({
  id: true,
  created_at: true,
}).partial();

export type ConfigsStepPostSignQaUpdateT = z.infer<
  typeof ConfigsStepPostSignQaUpdate
>;
